import { ActionIcon, Group, Select, TextInput } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useState } from "react";

const ROLE_OPTIONS = [
	{ value: "admin", label: "Admin" },
	{ value: "manager", label: "Manager" },
	{ value: "viewer", label: "Viewer" },
];

interface UserFiltersProps {
	searchTerm: string;
	roleFilter: string;
	onSearchChange: (value: string) => void;
	onRoleFilterChange: (value: string) => void;
}

function UserFilters({
	searchTerm,
	roleFilter,
	onSearchChange,
	onRoleFilterChange,
}: UserFiltersProps) {
	const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
	const [debouncedSearchTerm] = useDebouncedValue(localSearchTerm, 500);

	useEffect(() => {
		onSearchChange(debouncedSearchTerm);
	}, [debouncedSearchTerm, onSearchChange]);

	useEffect(() => {
		setLocalSearchTerm(searchTerm);
	}, [searchTerm]);

	return (
		<Group mb="md">
			<TextInput
				placeholder="Search users..."
				value={localSearchTerm}
				onChange={(event) => setLocalSearchTerm(event.currentTarget.value)}
				style={{ flex: 1 }}
				rightSection={
					localSearchTerm ? (
						<ActionIcon
							variant="subtle"
							color="gray"
							onClick={() => setLocalSearchTerm("")}
							aria-label="Clear search">
							<IconX size={16} />
						</ActionIcon>
					) : null
				}
			/>
			<Select
				placeholder="Filter by Role"
				value={roleFilter}
				onChange={(value) => onRoleFilterChange(value || "")}
				data={ROLE_OPTIONS}
				clearable
			/>
		</Group>
	);
}

export default UserFilters;
